import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from '@dotone/react-ui-core/hooks';
import { useShallowEqualSelector, useTranslate } from '@hooks';
import { updateNetworkUser, createNetworkUser } from '@actions';
import {
  FormBasic as Form,
  FormGroup,
  Label,
  Input,
  NetworkUserStatusSelect,
  NetworkUserAvatar,
} from '@dotone/react-ui-core';

const NetworkUserForm = ({ onCancel, defaultValues = {}, ...otherProps }) => {
  const { t } = useTranslate('networkUser', 'model');
  const dispatch = useDispatch();
  const [imageUrl, setImageUrl] = useState(defaultValues.avatarCdnUrl);
  const { data, isLoading, isSuccess, status } = useShallowEqualSelector(
    ({ networkUserCreate, networkUserUpdate }) => ({
      data: defaultValues.id ? networkUserUpdate.data : networkUserCreate.data,
      isLoading: networkUserCreate.isLoading || networkUserUpdate.isLoading,
      isSuccess: networkUserCreate.status === 'success' || networkUserUpdate.status === 'success',
      status: networkUserCreate.status || networkUserUpdate.status,
    })
  );

  const { handleSubmit, setError, connectForm } = useForm({ defaultValues });

  const handleSubmitForm = ({ id, ...values }) => {
    const newValues = {
      ...values,
      avatarCdnUrl: imageUrl,
    };
    if (id) {
      dispatch(updateNetworkUser(id, newValues));
    } else {
      dispatch(createNetworkUser(newValues));
    }
  };

  useEffect(() => {
    if (onCancel && isSuccess && !isLoading) onCancel();
  }, [onCancel, isSuccess, isLoading]);

  useEffect(() => {
    if (status === 'error' && data.message) {
      Object.keys(data.message).forEach((key) =>
        setError(key, { type: 'custom', message: data.message[key] })
      );
    }
  }, [status, data.message, setError]);

  return (
    <Form
      forModal
      onSubmit={handleSubmit(handleSubmitForm)}
      onCancel={onCancel}
      submitting={isLoading}
      {...otherProps}
    >
      {connectForm(
        <>
          <FormGroup>
            <Label required>{t('email')}</Label>
            <Input name="email" type="email" rules={{ required: true }} />
          </FormGroup>
          <FormGroup>
            <Label required>{t('firstName')}</Label>
            <Input name="firstName" rules={{ required: true }} />
          </FormGroup>
          <FormGroup>
            <Label required>{t('lastName')}</Label>
            <Input name="lastName" rules={{ required: true }} />
          </FormGroup>
          {defaultValues.emailVerified && (
            <FormGroup>
              <Label required>{t('status')}</Label>
              <NetworkUserStatusSelect name="status" rules={{ required: true }} />
            </FormGroup>
          )}
          <FormGroup>
            <Label>{t('avatarCdnUrl')}</Label>
            <NetworkUserAvatar cdnUrl={imageUrl} onSuccess={setImageUrl} />
          </FormGroup>
        </>
      )}
    </Form>
  );
};

export default NetworkUserForm;
